/**
 * Convert a 2D array into a CSV string
 */
export function arrayToCsv(data) {
    // Check if data is undefined or empty
    if (!data || data.length === 0 || data[0].length === 0) {
        console.warn("arrayToCsv received empty or undefined data");
        console.log(data);
        return "";
    }
    // First, transpose the data
    const transposed = data[0].map((_, colIndex) => data.map((row) => row[colIndex]));

    // Then convert to CSV
    return transposed
        .map(
            (column) =>
                column
                    .map(String) // convert every value to String
                    .map((v) => v.replaceAll('"', '""')) // escape double quotes
                    .map((v) => `"${v}"`) // quote it
                    .join(",") // comma-separated
        )
        .join("\r\n"); // columns starting on new lines
}

export function downloadBlob(content, filename, contentType) {
    // Create a blob
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement("a");
    pom.href = url;
    pom.setAttribute("download", filename);
    pom.click();
}
